import { Directive, HostBinding, Input } from '@angular/core';
import { IdService } from '../common/id.service';
import { NavigationService } from './navigation.service';
/**
 * @hidden
 */
var LogicalRowDirective = /** @class */ (function () {
    function LogicalRowDirective(idService, navigation) {
        this.idService = idService;
        this.navigation = navigation;
        this.logicalSlaveRow = false;
        this.logicalSlaveCellsCount = 0;
        this.dataRowIndex = -1;
    }
    Object.defineProperty(LogicalRowDirective.prototype, "hostRole", {
        get: function () {
            return this.logicalSlaveRow ? 'presentation' : 'row';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LogicalRowDirective.prototype, "ariaRowIndex", {
        get: function () {
            return this.logicalRowIndex + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LogicalRowDirective.prototype, "ariaOwns", {
        get: function () {
            if (this.logicalSlaveRow || this.logicalSlaveCellsCount === 0) {
                return undefined;
            }
            var ids = [];
            var total = this.logicalCellsCount + this.logicalSlaveCellsCount;
            for (var cellIndex = this.logicalCellsCount; cellIndex < total; cellIndex++) {
                ids.push(this.idService.cellId(this.logicalRowIndex, cellIndex));
            }
            return ids.join(' ');
        },
        enumerable: true,
        configurable: true
    });
    LogicalRowDirective.prototype.ngOnChanges = function () {
        if (this.navigation.enabled) {
            this.register();
        }
    };
    LogicalRowDirective.prototype.ngOnDestroy = function () {
        if (!this.logicalSlaveRow) {
            this.navigation.unregisterRow(this);
        }
    };
    LogicalRowDirective.prototype.register = function () {
        if (!this.logicalSlaveRow) {
            this.navigation.registerRow(this);
        }
    };
    LogicalRowDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoGridLogicalRow]'
                },] },
    ];
    /** @nocollapse */
    LogicalRowDirective.ctorParameters = function () { return [
        { type: IdService, },
        { type: NavigationService, },
    ]; };
    LogicalRowDirective.propDecorators = {
        'logicalRowIndex': [{ type: Input },],
        'logicalSlaveRow': [{ type: Input },],
        'logicalCellsCount': [{ type: Input },],
        'logicalSlaveCellsCount': [{ type: Input },],
        'dataRowIndex': [{ type: Input },],
        'dataItem': [{ type: Input },],
        'hostRole': [{ type: HostBinding, args: ['attr.role',] },],
        'ariaRowIndex': [{ type: HostBinding, args: ['attr.aria-rowindex',] },],
        'ariaOwns': [{ type: HostBinding, args: ['attr.aria-owns',] },],
    };
    return LogicalRowDirective;
}());
export { LogicalRowDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/navigation/logical-row.directive.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/navigation/logical-row.directive.js
// module chunks = vendor